import React from 'react';
import { Input, Checkbox, FormSection, FormActions } from '../../../../design-system/components';
import { useInertiaForm } from '../../../../hooks';
import { admin_settings_webhooks_path } from '../../../../lib/routes';

export default function WebhookForm({ webhook, action, method, supported_events, disabled_events = [] }) {
  const form = useInertiaForm({
    url: webhook.url || '',
    events: Array.isArray(webhook.events) ? webhook.events : [],
  });
  const handleEventToggle = (event, checked) => {
    const current = form.data.events;
    if (checked) {
      form.setData('events', [...current, event]);
    } else {
      form.setData(
        'events',
        current.filter((e) => e !== event),
      );
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (method === 'post') {
      form.post(action);
    } else {
      form.patch(action);
    }
  };

  const disabledSet = new Set(disabled_events);

  return (
    <form onSubmit={handleSubmit}>
      <FormSection
        heading="Endpoint Configuration"
        description="Configure the webhook endpoint URL and events to subscribe to."
      >
        <div className="space-y-4">
          <Input
            label="URL"
            name="url"
            type="url"
            placeholder="https://example.com/webhooks"
            value={form.data.url}
            onChange={(e) => form.setData('url', e.target.value)}
            error={form.getError('url')}
            helperText="The HTTPS URL where webhook payloads will be sent."
          />
        </div>
      </FormSection>

      <FormSection
        heading="Event Subscriptions"
        description="Select which events should trigger this webhook."
      >
        <div className="grid gap-3 sm:grid-cols-2">
          {supported_events.map((event) => {
            const isDisabled = disabledSet.has(event);
            return (
              <div key={event}>
                <Checkbox
                  label={event}
                  checked={form.data.events.includes(event)}
                  onChange={(e) => handleEventToggle(event, e.target.checked)}
                />
                {isDisabled && (
                  <p className="ml-6 text-xs text-warning-600">
                    Globally disabled in Event Settings
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </FormSection>

      <FormActions
        submitLabel={method === 'post' ? 'Create Endpoint' : 'Update Endpoint'}
        processing={form.processing}
        cancelHref={admin_settings_webhooks_path()}
      />
    </form>
  );
}
